import React from 'react';
import { AlertBanner } from '@spark';

export default function MeasuredRunOutcomeBanner({ outcome }) {
  if (!outcome?.message || !outcome.tone || outcome.kind === 'in_progress') {
    return null;
  }
  return (
    <div style={{ marginBottom: 16 }}>
      <AlertBanner
        feedback={outcome.tone === 'processing' ? 'info' : outcome.tone}
        showIcon
        text={outcome.message}
        showButton={false}
        showCloseButton={false}
      />
    </div>
  );
}
